__webpack_require__.p = "/amasis-web/";